export const useScreenshotAware = () => {
    // No-op on web
};
